// /src/components/core/NotificationsBell.jsx
// Header notifications bell + unread count pill (design note
// docs/briefs/2026-09-22-notification-lifecycle-and-moderation-transparency-design-note.md §3).
// Presentational only: the unread count and the click handler come from HeaderButtonsFeed,
// which owns the fetch. Shared by all three header branches so they cannot drift apart.
//
// Unread > 0: BellRing in the notificationAlert colour. Zero: the plain grey Bell.

import { Bell, BellRing } from 'lucide-react';
import { tokens } from '../../styles/designTokens';

function NotificationsBell({ unreadCount, onClick, title }) {
  const hasUnread = unreadCount > 0;
  const Icon = hasUnread ? BellRing : Bell;

  return (
    <div style={{ position: 'relative' }}>
      {/* Raw <button>, not StandardButton: no StandardButton shape is a transparent 40px circle
          with a 22px icon (circle always fills a background; inline's icon tier is 12-14px), and
          BellRing is not in its icon registry. LAYOUT.md § Usage Rule exception, recorded here. */}
      <button
        onClick={onClick}
        title={title}
        style={{
          width: '40px', height: '40px', borderRadius: '50%', padding: 0,
          background: 'transparent', border: 'none', cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}
      >
        <Icon
          size={22}
          color={hasUnread ? tokens.colors.notificationAlert : tokens.colors.textSecondary}
          strokeWidth={tokens.icon.strokeWidth}
        />
      </button>
      {hasUnread && (
        <span style={{
          position: 'absolute', top: '-2px', right: '-2px',
          background: tokens.colors.destructive, color: 'white', borderRadius: '10px',
          minWidth: '18px', height: '18px', padding: '0 5px',
          fontSize: '11px', fontWeight: 'bold',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          border: '2px solid white', boxShadow: '0 1px 2px rgba(0,0,0,0.2)',
          pointerEvents: 'none'
        }}>
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </div>
  );
}

export default NotificationsBell;
